import styled, { keyframes, css } from 'styled-components'
import { media } from '../../layouts/utils'
import {
    colorNeutralDark,
    borderRadius,
    fontSize,
    shadow,
    fontFamily,
    colorBrandPrimary,
    colorNeutralGrey,
} from '../../global.style'
import Icon from '../Icons'

function hexToRGBA(hex, a = 1) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || '')
  const r = parseInt(result[1], 16)
  const g = parseInt(result[2], 16)
  const b = parseInt(result[3], 16)
  return result ? `rgba(${r},${g},${b},${a})` : ''
}

export const Wrapper = styled.div`
  position: relative;
  box-sizing: border-box;
  //min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-feature-settings: 'kern' 1;
  font-kerning: normal;
  -webkit-font-smoothing: antialiased; /* Chrome, Safari */
  -moz-osx-font-smoothing: grayscale; /* Firefox */
`

export const Control = styled.aside`
  width: fit-content;
  position: absolute;
  z-index: 1;
  top: 2rem;
  left: 2rem;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 2rem);
  overflow: hideen;

  ${media.phone`
      width: 100%;
      top: 0;
      left: 0;
      box-sizing: border-box;
      padding: 0px;
      min-width: 100%;
    `}
`

export const LocationAlert = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 100%;
  z-index: 10;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;

  ${media.phone`
    top: 10px;
    right: auto;
    bottom: auto;
    height: auto;
    padding: 0 16px;
  `}
`

export const AlertWrapper = styled.div`
  color: ${colorBrandPrimary.darkMarine};
  background: #cdf3f7;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08), 0px 0px 1px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  overflow: hidden;

  > div:nth-child(1) {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px;

    ${media.phone`
      padding: 16px;
    `}
  }
`

export const AlertLoadingBar = styled.div`
  height: 4px;
  background: ${colorBrandPrimary.marine};

  @keyframes slideToLeft {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-100%);
    }
  }

  animation: 8s ease-in 0s slideToLeft;
  width: 100%;
`

export const MessageLocationAlert = styled.span`
  margin-left: 16px;
  font-size: 14px;
  line-height: 24px;

  ${media.phone`
    width: 100%;
  `}
`

export const Form = styled.form`
  outline: none;
  outline-style: none;
  border: none;
  background-color: white;
  border-radius: ${borderRadius.md};
  box-shadow: ${shadow.level1};
  box-sizing: border-box;
  color: ${colorBrandPrimary.marine};
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  font-family: ${fontFamily.neutral};
  height: fit-content;
  max-width: 410px;
  min-width: 410px;
  padding: 1.5rem 1rem;
  width: 100%;

  ${media.phone`
    min-width: 0;
    border-radius: 0;
    max-width: 100%;
  `}
`

export const Filters = styled.div`
  flex: 1;
  flex-wrap: wrap;
  display: flex;
  margin-top: 1rem;

  a {
    margin-right: 8px;
  }
`

export const Button = styled.a`
  cursor: pointer;
  background-color: ${hexToRGBA(colorBrandPrimary.marine, 0.08)};
  border-radius: ${borderRadius.pill};
  border: none;
  text-decoration: none;
  box-sizing: border-box;
  color: ${colorBrandPrimary.marine};
  display: inline-block;
  font-family: ${fontFamily.neutral};
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  left: 2rem;
  outline-style: none;
  outline: none;
  padding: 0.3rem 1rem;
  transition: color 0.1s ease-in-out, background-color 0.1s ease-in-out;
  &.active {
    color: white;
    background-color: ${hexToRGBA(colorBrandPrimary.marine, 1)};
  }
  &[disabled] {
    cursor: auto;
  }
`

export const InputWrapper = styled.div`
  background-color: white;
  border-color: white;
  border-radius: ${borderRadius.pill};
  box-shadow: ${shadow.level1};
  box-sizing: border-box;
  outline-color: ${colorBrandPrimary.marine};
  padding: 0.8rem 1.2rem 0.8rem 1rem;
  width: 100%;
  display: flex;
  align-items: center;
  & img {
    border: 0;
    padding: 0;
    margin: 0;
    margin-right: 0.5rem;
  }

  ${media.phone`
    width: 90%;
  `}
`

export const InputButton = styled.button`
  border: 0;
  background: transparent;
  padding: 0;
  margin: 0;
  height: 24px;
`

export const InputClear = styled.button`
  border: 0;
  background: transparent;
  padding: 0;
  margin: 0;
  height: 16px;
  display: flex;
  margin-right: 4px;

  img {
    width: 16px;
  }
`

export const Query = styled.input`
  color: ${colorBrandPrimary.marine};
  font-size: ${fontSize.xs};
  font-weight: bold;
  width: 100%;
  border: 0;
  outline: none;
  &::placeholder {
    color: ${hexToRGBA(colorBrandPrimary.marine, 0.5)};
    opacity: 1;
  }

  ${media.smallPhone`
    font-size: 12px;
  `}
`

export const Results = styled.div`
  outline: none;
  outline-style: none;
  border: none;
  display: flex;
  flex-direction: column;
  height: fit-content;
  max-width: 410px;
  min-width: 410px;
  width: 101%;
  margin-bottom: 1rem;
  scrollbar-width: none;
  overflow-y: auto;
  margin-top: 20px;
  scrollbar-width: thin;
  scrollbar-color: ${colorBrandPrimary.marine} transparent;

  &::-webkit-scrollbar {
    width: 7px;
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${colorBrandPrimary.marine};
    border-radius: 20px;
  }

  ${media.phone`
      flex-direction: row;
      padding: 0 10px 10px;
      position: absolute;
      top: calc(100vh - 220px);
      max-width: 100%;
      min-width: 100%;
      left: 0;
      margin: 0;
    `}
`

export const Result = styled.div`
  outline: none;
  outline-style: none;
  border: none;
  background-color: white;
  border-radius: ${borderRadius.md};
  box-shadow: ${shadow.level1};
  box-sizing: border-box;
  color: ${colorBrandPrimary.marine};
  padding: 2rem 1.5rem;
  width: 100%;
  display: flex;
  flex: 0 0 auto;
  font-family: ${fontFamily.brand};
  margin-top: 1rem;
  &.selected {
    border: 2px solid ${colorBrandPrimary.marine};
  }
  &:first-child {
    margin-top: 0;
  }

  ${media.phone`
      min-width: 80vw;
      max-width: 88vw;
      padding: 1.3em;
      margin-top: 0;
      margin-left: 1rem;

      &:first-child {
        margin-left: 0;
      }
    `}

  @media (max-width: 320px) {
    font-size: 12px;
    max-height: 170px;
    overflow-y: auto;
  }
`

export const ResultIcon = styled.div`
  text-decoration: none;
  color: ${colorBrandPrimary.marine};

  &.asButton {
    cursor: pointer;
  }
  margin-right: 2rem;
  & img {
    align-self: center;
    display: block;
    width: 22px;
    height: 22px;
  }
  & strong {
    padding: 0;
    font-weight: normal;
    font-style: normal;
    font-size: 18px;
    display: block;
  }
  & span {
    padding: 0;
    margin: 0;
    display: block;
    font-weight: 100;
    margin-bottom: 10px;
    font-size: 12px;
    font-family: ${fontFamily.neutral};
  }

  @media (max-width: 320px) {
    & strong {
      font-size: 12px;
    }
    & a {
      font-size: 9px;
    }
  }
`

export const ResultIconSVG = styled.div`
  background-color: ${colorBrandPrimary.marine};
  mask: url(${(props) => props.svgUrl}) no-repeat center;
  mask-size: 100%;
  width: 24px;
  height: 24px;
`

export const ResultInfo = styled.div`
  &.asButton {
    cursor: pointer;
  }
  flex: 1;
  & strong {
    font-weight: normal;
  }
  & address {
    color: ${colorNeutralDark[90]};
    font-weight: 100;
    margin-top: 0.3rem;
    margin-bottom: 0.5rem;
    font-style: normal;
    line-height: 1.2rem;
    font-family: ${fontFamily.neutral};
  }
`

export const NotFoundWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const NotFoundText = styled.p`
  font-weight: bold;
  font-size: 15px;
  margin-left: 10px;
  font-family: ${fontFamily.neutral};
`

const spinAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const LoadingWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const LoadingSpinner = styled.div`
  animation: ${spinAnimation} 1s linear infinite;
  transform: translateZ(0);
  border-radius: 50%;
  border: 3px solid ${colorBrandPrimary.turquoise};
  border-top: 3px solid ${colorNeutralGrey[30]};
  background: transparent;
  width: ${(props) => (props.size ? `${props.size}px` : '24px')};
  height: ${(props) => (props.size ? `${props.size}px` : '24px')};
`
export const BubbleMarker = styled.div`
  position: relative;
  background: ${(props) =>
    props.selected
      ? `${colorBrandPrimary.turquoise}`
      : `${colorBrandPrimary.marine}`};
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 44px;
  border-radius: 6px;
  padding: 0px;
  cursor: pointer;

  &:after {
    content: '';
    position: absolute;
    display: block;
    width: 0;
    z-index: 1;
    border-style: solid;
    border-color: ${(props) =>
        props.selected
          ? `${colorBrandPrimary.turquoise}`
          : `${colorBrandPrimary.marine}`}
      transparent;
    border-width: 9px 7px 0;
    bottom: -9px;
    left: 50%;
    margin-left: -7px;
  }
`

export const QuitButton = styled.a`
  width: 48px;
  height: 48px;
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 2;
  background-image: url('/parcerias/assets/map/button_X_mousehover.svg');
  background-size: 100%;
  cursor: pointer;
  transition: background 0.3s;

  ${media.phone`
    top: 37px;
    right: 14px;
    width: 27px;
    height: 27px;
  `}
`

export const TituloHistorico = styled.h3`
  font-size: 16px;
  line-height: 20.8px;
  font-family: ${fontFamily.brand};
  font-weight: normal;
  margin-bottom: 16px;
`

export const HistoricoContainer = styled.div`
  padding: 24px 24px 0px;
`

export const HistoricoItem = styled.div`
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`

export const HistoricoItemTexto = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;

  & span {
    font-size: 16px;
  }
`

export const HistoricoIcon = styled(Icon)`
  margin-right: 17px;
`

export const HistoricoClear = styled.button`
  border: 0;
  background: transparent;
  padding: 0;
  margin: 0;
  height: 12px;
  display: flex;
  margin-right: 4px;

  img {
    width: 12px;
  }
`

export const Settings = styled.div`
  box-shadow: ${shadow.level1};
  border-radius: ${borderRadius.md};
  background-color: white;
  padding: 18px;
  position: relative;

  & label {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
    color: ${colorBrandPrimary.darkMarine};
  }

  ${media.phone`
    top: 12px;
    position: relative;
    right: 16px;
    float: right;
    bottom: unset;

    & label {
      font-size: 12px;
    }
  `}
`

export const LabelGeolocalizacao = styled.label`
  input[type='checkbox'] {
    transform: scale(1.5);
    margin-right: 10px;
  }
  input[type='checkbox']:checked {
    ${(props) =>
      props.applyStyle
        ? css`
            filter: hue-rotate(389deg) saturate(21) sepia(0.6);
          `
        : null}
  }
`

export const WrapperSettings = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export const SmallSettings = styled.div`
  display: flex;
  flex-direction: row;
`

export const SettingsButton = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  box-shadow: ${shadow.level1};
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  float: right;
  margin-left: 8px;
  cursor: pointer;

  ${media.phone`
    width: 32px;
    height: 32px;
    margin: 16px 16px 0 0;
  `}
`

export const DesktopSettingsWrapper = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 41px;
  right: 60px;
`